import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { useGetAllUsersQuery, useGetPermissionsQuery, useAddUserMutation, useSendInvitationMutation } from '../../services/api';
import AdminManagementHeader from './AdminManagementHeader';
import AdminManagementTable from './AdminManagementTable';
import AddUserDialogBox from './AddUserDialogBox';
import ErrorSnackbar from '../../components/ErrorSnackbar';

const AdminManagement = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const { data: usersData, refetch: refetchUsers } = useGetAllUsersQuery(' ');
    const { data: permissionsData } = useGetPermissionsQuery();
    const [addUserMutation] = useAddUserMutation();
    const [sendInvitation] = useSendInvitationMutation();

    const { company } = useSelector((state) => state.global);

    const [userData, setUserData] = useState({ name: '', email: '', country: '', phoneNumber: '', role: '' });
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
    const [openDialog, setOpenDialog] = useState(false);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserData({
            ...userData,
            [name]: value,
        });
    };

    // Handle add user
    const handleAddUser = async () => {
        try {
            if (!userData.name || !userData.email || !userData.role) {
                showSnackbar('Please fill all fields', 'error');
            } else {
                const addUserResponse = await addUserMutation({
                    name: userData.name,
                    email: userData.email,
                    role: userData.role,
                    company: company,
                });

                if (addUserResponse.error) {
                    showSnackbar('User already exists', 'error');
                } else {
                    sendInvitation({
                        name: userData.name,
                        email: userData.email,
                    });

                    showSnackbar('Power Admin added successfully', 'success');
                    refetchUsers();
                }
            }
        } catch (error) {
            console.error('Error adding user:', error);
            showSnackbar('Failed to add user', 'error');
        } finally {
            handleCloseDialog();
        }
    };

    // show snackbar
    const showSnackbar = (message, severity) => {
        setSnackbar({ open: true, message, severity });
    };

    return (
        <Box m={isSmallScreen ? '1rem' : '1rem 2.5rem'}>
            <AdminManagementHeader handleOpenDialog={handleOpenDialog} isSmallScreen={isSmallScreen} />
            {usersData && permissionsData && (
                <Box marginTop="1rem">
                    <AdminManagementTable userData={usersData} permissionsData={permissionsData} refetch={refetchUsers} showSnackbar={showSnackbar} isSmallScreen={isSmallScreen} />
                </Box>
            )}
            <AddUserDialogBox open={openDialog} handleCloseDialog={handleCloseDialog} userData={userData} handleInputChange={handleInputChange} handleAddUser={handleAddUser} />
            <ErrorSnackbar open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })} />
        </Box>
    );
};

export default AdminManagement;
